<template>
<!-- v-on="clickable ? { click: () => test() } : {}" -->
  <v-container>
    <v-row class="mx-0" :class="textCenter ? 'text-center' : ''" v-for="item in items" :key="item.id">
      
        <v-col :cols="col" class="pt-0 d-flex align-center justify-center">
          <v-avatar :size="imgSize" class="ml-1">
            <img :src="`${item.src}`" :alt="item.alt"
                    :height="imgSize" :width="imgSize">
          </v-avatar>
        </v-col>
        <v-col :cols="12-col">
          <v-card-text class="py-0 font-weight-bold">{{ item.name }}</v-card-text>
          <v-card-text class="pt-0 pb-2 font-weight-bold">{{ item.date }}</v-card-text>
          <v-card-text class="pt-0 pb-1" v-html="item.summary">{{  }}</v-card-text>

          <v-dialog v-if="item.details" v-model="item.dialog" width="500" >
            <template v-slot:activator="{ on, attrs }">
              <v-btn text class="text-capitalize" v-bind="attrs" v-on="on">Read More</v-btn>
            </template>
            <v-card>
              <v-card-title class="headline grey lighten-2">
                {{ item.name }}
              </v-card-title>

              <v-card-text>
                {{ item.details }}
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black" text @click="item.dialog = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn v-for="link in item.links" :key="link.id" :color='link.color' plain icon 
                large :href="link.href" target="_blank" class="pl-2 pt-0">
            <v-icon>{{ link.icon }}</v-icon>
          </v-btn>

          <v-divider v-if="textCenter && item.alt!=items[items.length-1].alt" class="my-4"></v-divider>

        </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ListCard',
  methods: {
    toPage(page_path){
      window.open(page_path, '_blank').focus()
      // this.$router.push({path: page_path})
    }
  },
  computed: {
    imgSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 100
        case 'sm': return 100
        case 'md': return 100
        case 'lg': return 100
        case 'xl': return 100
      }
    },
    col() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 2
        case 'md': return 2
        case 'lg': return 2
        case 'xl': return 2
      }
    },
    textCenter() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return false
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
    },
  },
  props: ['items']
}
</script>

<style>

</style>